import React, { useState } from "react";
import { Button, Modal, Box } from "@mui/material";
import NewModelForm from "./NewModelForm";
import axios from "axios";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import TrainedModelFormFields from "./TrainedModelFormFields";

const ExportTrainingToModelZooButton = ({
  model,
  refreshModels,
  variant = "outlined",
  disabled = false,
}) => {
  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const handleExport = async (modelInfoForm) => {
    if (
      !modelInfoForm.modelName.trim() ||
      !modelInfoForm.description.trim() ||
      !modelInfoForm.application
    ) {
      alert("Please fill in all required fields before exporting.");
      return;
    }

    try {
      // Step 1: PATCH metadata
      await axios.patch(`/models/${model.id}`, {
        name: modelInfoForm.modelName,
        info: {
          description: modelInfoForm.description,
          application: modelInfoForm.application,
          modelTask: modelInfoForm.modelTask,
          modelFramework: modelInfoForm.modelFramework,
          training_params: modelInfoForm.training_params,
          metrics: modelInfoForm.metrics,
        },
        in_model_zoo_public: modelInfoForm.in_model_zoo_public,
        in_model_zoo_private: modelInfoForm.in_model_zoo_private,
      });

      // Step 2: Upload test images if any
      const testImages = modelInfoForm.modelTestImages || [];
      if (testImages.length > 0) {
        const formData = new FormData();
        testImages.forEach((file) => formData.append("test_images", file));

        await axios.post(`/models/${model.id}/test_images`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      }

      refreshModels?.();
      handleCloseModal();
      console.log("Model exported to Model Zoo successfully.");
    } catch (error) {
      console.error("Error:", error.response?.data || error.message);
      alert(
        `Something went wrong: ${error.response?.data?.detail || error.message}`,
      );
    }
  };

  const initialValues = {
    modelName: model.name || "",
    modelFile: null,
    description: model.info?.description || "",
    application: model.info?.application || "",
    modelTask: model.info?.modelTask || "",
    modelFramework: model.info?.modelFramework || "",
    modelTestImages: [], // start empty; user can upload new test images
    training_params: {
      epochs: model.info?.training_params?.epochs || "",
      batchSize: model.info?.training_params?.batch || "",
      imgsz: model.info?.training_params?.imgsz || "",
      // imageSize: {
      //   imageHeight: model.info?.training_params?.imageSize?.imageHeight || '',
      //   imageWidth: model.info?.training_params?.imageSize?.imageWidth || ''
      // }
    },
    metrics: {
      // inferenceTime: model.info?.metrics?.['metrics/precision(B)'] || '',
      inferenceTime: model.info?.metrics?.["metrics/inference_time"] || "",
      mAP: model.info?.metrics?.["metrics/mAP50(B)"] || "",
    },
    in_model_zoo_public: model.in_model_zoo_public || false,
    in_model_zoo_private: model.in_model_zoo_private || false,
  };

  return (
    <>
      <Button
        startIcon={<ExitToAppIcon />}
        variant={variant}
        sx={{
          textTransform: "none",
          borderRadius: 4,
          color: "#16a4b0",
          boxShadow: "none",
          fontSize: "16px",
          ...(variant === "text" || variant === "txt"
            ? { border: "none", borderColor: "transparent" }
            : { border: "1px solid #16a4b0", borderColor: "#16a4b0" }),
        }}
        onClick={handleOpenModal}
        disabled={disabled}
      >
        Export to Model Zoo
      </Button>

      <Modal open={openModal} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "white",
            p: 4,
            borderRadius: 3,
            width: { xs: "90%", sm: "40%" },
            maxHeight: "80vh",
            overflowY: "auto",
          }}
        >
          <NewModelForm
            initialValues={initialValues}
            onSubmit={handleExport}
            showFileInput={false} // no file input for export
            handleCloseModal={handleCloseModal}
            FieldsComponent={TrainedModelFormFields} // use the trained model fields
          />
        </Box>
      </Modal>
    </>
  );
};

export default ExportTrainingToModelZooButton;
